import { multiply, volatileSum, zero } from "~/utils/PriceUtils";
import { isTariffSurchargeEnabled } from "~/features/cart/cart/utils/cartUtils";
import type { CartEntrySummaryViewModel } from "~/features/cart/cartV2/models/ProductTableViewModel";
import type { ResolvedProductGroup } from "~/features/cart/cartV2/utils/selectResolvedGroupedEntryV2";

export function buildCartEntrySummary(
  resolvedGroup: Pick<ResolvedProductGroup, "lineItems">,
  hasLockedLines = false,
): CartEntrySummaryViewModel {
  const lineItems = resolvedGroup.lineItems;
  const lineItemCount = lineItems.length;
  const totalQuantity = lineItems.reduce((sum, item) => sum + item.quantity, 0);
  const subtotal =
    lineItems.length > 0
      ? volatileSum(...lineItems.map((lineItem) => multiply(lineItem.netPrice ?? zero(), lineItem.quantity)))
      : null;
  const surchargeEnabled = isTariffSurchargeEnabled();

  return {
    totalQuantity,
    lineItemCount,
    subtotal,
    hasTariffSurcharge: surchargeEnabled && lineItems.some((lineItem) => !!lineItem.netPrice?.tariffSurcharge),
    hasIncludedSurcharge: surchargeEnabled && lineItems.some((lineItem) => (lineItem.netPrice?.surcharge ?? 0) > 0),
    canDeleteProduct: !hasLockedLines,
  };
}
